<div class="min-h-[80vh] flex items-center justify-center p-4">
  <div class="w-full max-w-md rounded-2xl bg-white/95 backdrop-blur-lg shadow-2xl border border-white/50 overflow-hidden">

    <div class="flex items-center justify-between rounded-t-2xl border-b border-blue-200/70 px-5 py-4 bg-linear-to-r from-blue-50/50 to-purple-50/50">
      <h3 class="text-lg font-semibold lg:text-xl text-neutral-800">
        Aceptar Presupuesto
      </h3>
    </div>

    <div class="p-5 flex flex-col gap-5">

      <custom-select
        label="Presupuesto"
        placeholder="BUSCAR PRESUPUESTO..."
        [formControlItem]="budgetControl"
        [options]="budgets"
        bindValue="value"
        bindLabel="label"
        bindSubLabel="subLabel"
        bindExtra="extra">
      </custom-select>

      <div class="flex flex-col gap-1">
        <label class="font-bold block mb-1 text-slate-700 text-sm tracking-wider">Fecha del documento</label>
        <input type="date" [(ngModel)]="date"
          class="w-full px-3 py-2 bg-slate-50 border border-slate-200 rounded-2xl text-xs font-bold text-slate-700 focus:bg-white focus:ring-4 focus:ring-blue-500/10 outline-none transition-all uppercase tracking-wider">
      </div>

      <div class="flex flex-col gap-2">
        <span class="font-bold block text-slate-700 text-sm tracking-wider">Convertir en</span>
        <div class="flex gap-3">
          <button type="button" (click)="accept('factura')" [disabled]="loading"
            class="flex-1 cursor-pointer py-3 bg-blue-600 text-white hover:bg-blue-500 rounded-xl font-bold text-sm tracking-wider transition-all uppercase shadow-lg shadow-blue-900/20 disabled:opacity-50 disabled:cursor-not-allowed">
            Factura
          </button>
          <button type="button" (click)="accept('albaran')" [disabled]="loading"
            class="flex-1 cursor-pointer py-3 bg-emerald-600 text-white hover:bg-emerald-500 rounded-xl font-bold text-sm tracking-wider transition-all uppercase shadow-lg shadow-emerald-900/20 disabled:opacity-50 disabled:cursor-not-allowed">
            Albarán
          </button>
          <button type="button" (click)="accept('devolucion')" [disabled]="loading"
            class="flex-1 cursor-pointer py-3 bg-red-600 text-white hover:bg-red-500 rounded-xl font-bold text-sm tracking-wider transition-all uppercase shadow-lg shadow-red-900/20 disabled:opacity-50 disabled:cursor-not-allowed">
            Devolución
          </button>
        </div>
      </div>

    </div>
  </div>
</div>
